/**
 * The stable ProblemDetails `title` the Mesterplan API answers 403 with when an account's
 * email is not confirmed in RsConnect. Partner invitations are matched by email address, so
 * the API refuses to show or convert them until the address is proven.
 */
export const EMAIL_UNVERIFIED_CODE = 'email_unverified';

/** Whether an API error is the 403 "email not confirmed" refusal. */
export function isEmailUnverifiedError(error: { status?: number; title?: string } | undefined): boolean {
  return error?.status === 403 && error.title === EMAIL_UNVERIFIED_CODE;
}

/**
 * RsConnect's email-confirmation page for this user; null when auth isn't via RsConnect
 * (no issuer configured), where there is nowhere to send the user.
 */
export function verifyEmailUrl(issuerUrl: string | undefined, email: string | null | undefined): string | null {
  if (!issuerUrl) {
    return null;
  }
  const base = issuerUrl.replace(/\/+$/, '');
  const params = new URLSearchParams({ product: 'mesterplan' });
  if (email) {
    params.set('email', email);
  }
  return `${base}/verify-email?${params.toString()}`;
}
